<template>
  <div class="outlineClass">
    <div class="part1" oncontextmenu = "return false" oncopy = "return false" onselectstart = "return false">
      <div class="cooperationPart1"></div>
      <div class="cooperationPart2"></div>
      <div class="cooperationPart3"></div>
      <div class="cooperationPart4"></div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "cooperation",
        data(){
          return{
            vShow:false,
          }

        },
          mounted(){
          window.setInterval(this.vShow=true,3000);
        }

    }
</script>

<style scoped>
.part1{
  width: 100%;
  min-height: 1000px;
}
  .cooperationPart1{
    min-height: 940px;
    background: url("../../assets/images/cooperation/en/cooperation_part1.png");
  }
.cooperationPart2{
  min-height: 778px;
  background: url("../../assets/images/cooperation/en/cooperation_part2.png");
}
.cooperationPart3{
  min-height: 1623px;
  background: url("../../assets/images/cooperation/en/cooperation_part3.png");
}
  .cooperationPart4{
    min-height: 867px;
    background: url("../../assets/images/cooperation/en/cooperation_part4.png");
  }
</style>



// WEBPACK FOOTER //
// src/components/cooperation/englishCooperation.vue